import { useEffect, useState } from "react";
import { Row, Col, Container } from "reactstrap";
// import logo from "../../images/Logo_nFiniti_black.svg";
import { Assist } from "./Assist";

// import CompanySelection from "./CompanySelection";
// import Service from "../../Services/service";
import { AxiosError, AxiosResponse } from "axios";
// import { catchError } from "../../Utlis/Utils";
import { useParams } from "react-router-dom";
import Service from "../../../../services";
import { catchError } from "../../../../utils/Utils";
import CompanySelection from "./ClientWelcomeSurvey";
import logo from "../../../../images/Logo_nFiniti_black copy.svg";

export function FirstPge(props:any) {

  const service = new Service();
  const [loader, setLoader] = useState<boolean>(false);

  const [next, setNext] = useState(false);
  const setNextPage = () => {
    setNext(true);
    // setLoader(true);
    // service.updateClientProductStatus().then(()=>{
    //   setNext(true);
    // }).catch((error:AxiosError)=>{
    //   catchError(error,true);
    // }).finally(()=>{
    //   setLoader(false);
    // })   
  };

  const { clientProductId } = useParams();

  useEffect(() => {

    const data = {
      sections: "getUserWelcomeQuestionStatus",
      screen: "LandingPage",
      isJsonReturnObject: false,
      clientProductId: clientProductId
    };

    service.firstLogin(data).then((response: AxiosResponse<any>) => {
      if (response.data && response.data.length > 0) {
        if (response.data[0].loginStatus) setNext(true);
      }

    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
  }, [])

  return (
    <>
      {!next ?
        <Container fluid className="WelcomeWrapper ">
          <Row>
            <Col md="12">
              <h3 className="mb-5 mt-4 text-center">
                <img src={logo} alt="Logo" className="nFinitiMainLogoBlack" />
              </h3>
            </Col>
            <Col md="12" className="csCard">
              <Assist setNext={setNextPage}  />
            </Col>
          </Row>
        </Container>
        :
        <CompanySelection  refreshComponent={props.refreshComponent}  />
      }
    </>
  );
}